import React from 'react';
import Navigation from './navigation';
import ImageUploader from './image-uploader';
import Avatar from 'react-avatar';
import dayjs from 'dayjs'
import Carousel, { Modal, ModalGateway } from 'react-images';

export default class CheersDetail extends React.Component {

    state = {
        pageState: 'normal',
        uploadInProgress: false,
        featureImgUrl: '',
        lightboxIsOpen: false,
        selectedIndex: 0,
    }

    toggleLightbox(selectedIndex) {
        this.setState(state => ({
            lightboxIsOpen: !state.lightboxIsOpen,
            selectedIndex,
        }));
    }

    componentDidMount() {
        if (!this.props.account.email) {
            this.props.getAccount();
        }
        if (this.props.contests === null) {
            this.props.getContests();
        }
    }

    updateFeatureImg(url) {
        this.setState({ featureImgUrl: url, uploadInProgress: false });
    }

    handleSubmit() {
        const { id } = this.props.match.params;
        const { featureImgUrl } = this.state;
        if (featureImgUrl !== '') {
            this.props.submitEntry(featureImgUrl, id);
            this.setState({ pageState: 'normal' });
        }
    }

    _iLike(entry) {
        return Boolean(entry.likes.find(ent => ent.user === this.props.account._id));
    }

    handleRemoveEntry(entryId) {
        const shouldRemove = confirm("Are you sure you want to remove this entry?");
        if (shouldRemove) {
            this.props.deleteEntry(entryId);
        }
    }

    _getLikeCountForUser() {
        const { id } = this.props.match.params;
        const { contests } = this.props;
        const contest = contests !== null && contests.length > 0 ? this.props.contests.find(contest => contest._id === id) : null;
        if (contest !== null) {
            let count = 0;
            contest.entries.map(ent => {
                return Boolean(ent.likes.find(like => like.user === this.props.account._id)) ? ++count : false;
            });
            return count;
        } else {
            return 0;
        }
    }

    _getLikeId(entry) {
        const like = entry.likes.find(ent => ent.user === this.props.account._id);
        return like._id;
    }

    renderWinner(entries) {
        const sortedEntries = entries.sort((a, b) => {
            return a.likes.length > b.likes.length ? -1 : 1;
        });
        const winner = sortedEntries[0];

        return (
            <div className="h-full p-8" key={winner._id}>
                <div
                    style={{ backgroundSize:'cover', backgroundPosition:'center', backgroundImage: `url(${winner.imageUrl})` }}
                    onClick={() => this.toggleLightbox(0)}
                    className="h-56 cursor-pointer w-full block rounded-t">
                </div>
                <div className="rounded-b bg-white flex items-center p-4">
                    <Avatar className="mr-4" size="50px" color="#80c7bc" round={true} name={`${winner.user.firstName} ${winner.user.lastName}`} />
                    <div>
                        <p className="font-bold text-gray-900">{Boolean(winner.user.firstName) ? `${winner.user.firstName} ${winner.user.lastName}` : 'Coworker'}</p>
                        <div className="flex items-center">
                            {this._iLike(winner) ?
                                <svg
                                    onClick={() => false}
                                    className="relative cursor-pointer h-5 w-5 mr-2 text-red-600 inline fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"/></svg>
                                :
                                <svg onClick={() => false} className="relative cursor-pointer h-5 w-5 mr-2 text-gray-600 fill-current inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path d="M12.76 3.76a6 6 0 0 1 8.48 8.48l-8.53 8.54a1 1 0 0 1-1.42 0l-8.53-8.54a6 6 0 0 1 8.48-8.48l.76.75.76-.75zm7.07 7.07a4 4 0 1 0-5.66-5.66l-1.46 1.47a1 1 0 0 1-1.42 0L9.83 5.17a4 4 0 1 0-5.66 5.66L12 18.66l7.83-7.83z"></path>
                                </svg>
                            }
                            <div className="text-lg font-semibold text-gray-700">{winner.likes.length}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { pageState, featureImgUrl, selectedIndex, lightboxIsOpen } = this.state;
        const { id } = this.props.match.params;
        const { contests, account } = this.props;
        const contest = contests !== null && contests.length > 0 ? this.props.contests.find(contest => contest._id === id) : {};
        const expired = dayjs(contest.expires).isBefore(dayjs(new Date()));
        const featuredImage = Boolean(contest.featuredImage) ? contest.featuredImage : require('../assets/bg-1.jpg');
        const hasEntries = Boolean(contest.entries);
        const images = hasEntries ? contest.entries.map(entry => {
            return { src: entry.imageUrl };
        }) : [];
        const canLikeMore = this._getLikeCountForUser() < 3;
        return (
            <div>
                <Navigation {...this.props} />
                {hasEntries &&
                    <ModalGateway>
                        {lightboxIsOpen && 
                            <Modal
                                onClose={() => this.toggleLightbox()}>
                                <Carousel
                                    currentIndex={selectedIndex}
                                    views={images} />
                            </Modal>
                        }
                    </ModalGateway>
                }
                <div
                    className="px-8 py-12 relative"
                    style={{ backgroundSize:'cover', backgroundPosition:'center', backgroundImage: `url(${featuredImage})` }}>
                    <div className="bg-gradient-black-to-transparent"></div>
                    <h2 className="relative text-center text-4xl lg:text-6xl text-white font-bold">{contest.name}</h2>
                </div>
                <div className="min-h-screen bg-gray-200 p-4">
                    {pageState === 'normal' &&
                        <button
                            className="p-4 bg-west-green hover:bg-west-green-400 items-center text-white leading-none rounded-full inline-flex"
                            onClick={() => this.setState({ pageState: 'new' })}>Add entry</button>
                    }
                    <div className="max-w-4xl mx-auto">
                        {Boolean(contest) &&
                            <div>
                                {pageState === 'normal' &&
                                    <div>
                                        <div>Details: {contest.content}</div>
                                        <div>Contest {expired ? 'ended' : 'expires'}: {dayjs(contest.expires).format('MMM DD, YYYY')}</div>
                                        <div>Entries: {images.length}</div>
                                        {Boolean(contest.entries) && contest.entries.length > 0 &&
                                            <div>
                                                {expired &&
                                                    <div>
                                                        <h3>Contest winner:</h3>
                                                        {this.renderWinner(contest.entries)}
                                                    </div>
                                                }
                                                <div className="grid mx-auto p-8">
                                                    {contest.entries.map((entry, idx) => (
                                                        <div className="h-full" key={entry._id}>
                                                            <div
                                                                style={{ backgroundSize:'cover', backgroundPosition:'center', backgroundImage: `url(${entry.imageUrl})` }}
                                                                onClick={() => this.toggleLightbox(idx)}
                                                                className="h-56 cursor-pointer w-full block rounded-t">
                                                            </div>
                                                            <div className="rounded-b bg-white flex items-center p-4">
                                                                <Avatar className="mr-4" size="50px" color="#80c7bc" round={true} name={`${entry.user.firstName} ${entry.user.lastName}`} />
                                                                <div>
                                                                    <p className="font-bold text-gray-900">{Boolean(entry.user.firstName) ? `${entry.user.firstName} ${entry.user.lastName}` : 'Coworker'}</p>
                                                                    <div className="flex items-center">
                                                                        {this._iLike(entry) ?
                                                                            <svg
                                                                                onClick={() => expired ? false : this.props.removeEntryLike(entry._id, this._getLikeId(entry))}
                                                                                className="relative cursor-pointer h-5 w-5 mr-2 text-red-600 inline fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"/></svg>
                                                                            :
                                                                            <svg onClick={() => expired ? false : (canLikeMore ? this.props.likeContestEntry(entry._id) : window.alert('You have like the maximum amount of entries for this contest.'))} className="relative cursor-pointer h-5 w-5 mr-2 text-gray-600 fill-current inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                                                <path d="M12.76 3.76a6 6 0 0 1 8.48 8.48l-8.53 8.54a1 1 0 0 1-1.42 0l-8.53-8.54a6 6 0 0 1 8.48-8.48l.76.75.76-.75zm7.07 7.07a4 4 0 1 0-5.66-5.66l-1.46 1.47a1 1 0 0 1-1.42 0L9.83 5.17a4 4 0 1 0-5.66 5.66L12 18.66l7.83-7.83z"></path>
                                                                            </svg>
                                                                        }
                                                                        <div className="text-lg font-semibold text-gray-700">{entry.likes.length}</div>
                                                                        {account.admin &&
                                                                            <div onClick={() => this.handleRemoveEntry(entry._id)} className="ml-4 text-lg font-semibold text-red-700 cursor-pointer">Remove</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                                {pageState === 'new' &&
                                    <div className="text-center">
                                        {Boolean(featureImgUrl) ?
                                            <div>
                                                <img className="mt-4 mb-8 block mx-auto" src={featureImgUrl} alt=""/>
                                                <button
                                                    className="p-4 bg-west-green hover:bg-west-green-400 items-center text-white leading-none lg:rounded-full flex lg:inline-flex"
                                                    onClick={() => this.handleSubmit()}>Submit entry</button>
                                            </div>
                                            :
                                            <div className="max-w-xs mx-auto">
                                                <ImageUploader
                                                    beginUpload={() => this.setState({ uploadInProgress: true })}
                                                    updateFeatureImg={url => this.updateFeatureImg(url)} {...this.props} />
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/cheers-detail.js